module.exports = __webpack_public_path__ + "static/img/leader5.9d1f600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leader5.png
// module id = qF1Y
// module chunks = 1